(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tj-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tj-reels')) {
    customElements.define('tj-reels', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.track = this.querySelector('.tj-reels__track');
        this.items = Array.from(this.querySelectorAll('[data-tj-reel]')).map(card => {
          const item = {
            card, video: card.querySelector('video'),
            play: card.querySelector('[data-tj-reel-play]'),
            visible: false, userPaused: false, userStarted: false
          };
          item.video.muted = true;
          item.video.defaultMuted = true;
          item.video.playsInline = true;
          item.video.loop = true;
          item.video.autoplay = false;
          item.video.pause();
          card.querySelector('.tj-reel__controls').hidden = false;
          item.play.addEventListener('click', () => {
            if (item.video.paused) {
              item.userPaused = false;
              item.userStarted = true;
              this.start(item);
            } else {
              item.userPaused = true;
              item.video.pause();
            }
          }, options);
          item.video.addEventListener('volumechange', () => {
            if (!item.video.muted) item.video.muted = true;
            this.renderState(item);
          }, options);
          ['play', 'pause', 'error'].forEach(event => {
            item.video.addEventListener(event, () => this.renderState(item), options);
          });
          this.renderState(item);
          return item;
        });
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const item = this.items.find(candidate => candidate.card === entry.target);
            if (!item) return;
            item.visible = entry.isIntersecting && entry.intersectionRatio >= .35;
            this.updatePlayback(item);
          });
        }, { threshold: [0, .35] });
        this.items.forEach(item => this.observer.observe(item.card));
        document.addEventListener('visibilitychange', () => {
          this.items.forEach(item => this.updatePlayback(item));
        }, options);
        this.motion.addEventListener('change', () => {
          this.items.forEach(item => this.updatePlayback(item));
        }, options);
        this.querySelectorAll('[data-tj-reels-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const card = this.track.querySelector('.tj-reel');
            const distance = card ? card.getBoundingClientRect().width + 12 : this.track.clientWidth;
            this.track.scrollBy({ left: Number(button.dataset.tjReelsDirection) * distance, behavior: this.motion.matches ? 'auto' : 'smooth' });
          }, options);
        });
        const updateNavigation = () => {
          const overflow = this.track.scrollWidth - this.track.clientWidth;
          this.querySelector('.tj-reels__navigation').hidden = overflow < 2;
          this.querySelector('[data-tj-reels-direction="-1"]').disabled = this.track.scrollLeft < 2;
          this.querySelector('[data-tj-reels-direction="1"]').disabled = this.track.scrollLeft >= overflow - 2;
        };
        this.track.addEventListener('scroll', updateNavigation, { ...options, passive: true });
        this.resizeObserver = new ResizeObserver(updateNavigation);
        this.resizeObserver.observe(this.track);
        updateNavigation();
      }

      start(item) {
        item.video.muted = true;
        item.video.defaultMuted = true;
        if (item.video.dataset.tjReelSrc) {
          item.video.src = item.video.dataset.tjReelSrc;
          delete item.video.dataset.tjReelSrc;
          item.video.load();
        }
        const attempt = item.video.play();
        if (attempt) attempt.catch(() => this.renderState(item));
      }

      updatePlayback(item) {
        const shouldPlay = item.visible && !document.hidden && !item.userPaused && (!this.motion.matches || item.userStarted);
        if (shouldPlay) this.start(item);
        else item.video.pause();
      }

      renderState(item) {
        const paused = item.video.paused;
        item.play.setAttribute('aria-label', paused ? item.play.dataset.labelPlay : item.play.dataset.labelPause);
        item.play.querySelector('[data-icon-play]').toggleAttribute('hidden', !paused);
        item.play.querySelector('[data-icon-pause]').toggleAttribute('hidden', paused);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.items?.forEach(item => item.video.pause());
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tj-size-charts"]) return;
  try {
    
(() => {
  const selectChart = (dialog, productId, title, chosenBlock) => {
    const panels = [...dialog.querySelectorAll('[data-chart-panel]')];
    const exact = panels.find(panel => panel.dataset.chartProduct === String(productId));
    const general = panels.find(panel => !panel.dataset.chartProduct && panel.dataset.chartContent === 'true');
    const selected = chosenBlock || exact || general;
    panels.forEach(panel => { panel.hidden = panel !== selected; });
    dialog.querySelector('[data-chart-fallback]').hidden = Boolean(selected);
    dialog.querySelector('[data-chart-product-title]').textContent = title || '';
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-size-chart-product]');
    if (!trigger) return;
    const dialog = document.getElementById('tj-size-chart');
    if (!dialog) return;
    selectChart(dialog, trigger.dataset.sizeChartProduct, trigger.dataset.sizeChartTitle);
  }, true);
  let selectedBlockId = null;
  const previewBlock = blockId => {
    const dialog = document.getElementById('tj-size-chart');
    if (!dialog) return;
    const panel = [...dialog.querySelectorAll('[data-chart-panel]')].find(item => item.dataset.chartBlock === blockId);
    if (!panel) return;
    selectChart(dialog, panel.dataset.chartProduct, panel.dataset.chartProductName, panel);
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
    if (!dialog.open) dialog.showModal();
  };
  document.addEventListener('shopify:block:select', event => {
    const dialog = document.getElementById('tj-size-chart');
    if (!dialog || !dialog.contains(event.target)) return;
    selectedBlockId = event.detail.blockId;
    previewBlock(selectedBlockId);
  });
  document.addEventListener('shopify:block:deselect', () => { selectedBlockId = null; });
  document.addEventListener('shopify:section:load', () => { if (selectedBlockId) previewBlock(selectedBlockId); });
})();

  } catch(e) { console.error(e); }
})();
})();
